<div class="progress-bar">
    <div class="progress-bar-track" [style.width.%]="percent"></div>
</div>